export default function initNewsletterPopup() {
    const newsletterPopup = document.querySelector("[data-newsletter-popup]");

    if (document.contains(newsletterPopup)) {
        const closeButton = document.querySelector("[data-button-popup-close]");
        const continueButton = document.querySelector(
            "[data-button-popup-continue]"
        );

        function showPopup() {
            setTimeout(() => {
                newsletterPopup.classList.remove("hidden");
            }, 15000);
        }

        if (
            window.localStorage.getItem("disable-newsletter-popup") ===
                undefined ||
            window.localStorage.getItem("disable-newsletter-popup") !== "1"
        ) {
            showPopup();
        }

        closeButton.addEventListener("click", () => {
            window.localStorage.setItem("disable-newsletter-popup", "1");
            newsletterPopup.classList.add("hidden");
        });

        continueButton.addEventListener("click", (event) => {
            event.preventDefault();
            window.localStorage.setItem("disable-newsletter-popup", "1");
            window.location = continueButton.href;
        });
    }
}
